import React from 'react'
import * as S from '../uploadFileModalWindow.style'

interface ButtonProps {
  notTrainedFileLimitAchieved: boolean
  onChange: any
  onClick: any
}

export const UploadButton: React.FC<ButtonProps> = ({ notTrainedFileLimitAchieved, onChange, onClick }) => {
  return (
    <>
      <S.ButtonWrapper>
        {!notTrainedFileLimitAchieved ? (
          <S.Button htmlFor="upload">{'Select files'}</S.Button>
        ) : (
          <S.DisabledButton htmlFor="upload">{'Select files'}</S.DisabledButton>
        )}
      </S.ButtonWrapper>
      <S.File
        id="upload"
        type="file"
        multiple="{true}"
        accept=".pdf, .txt, .doc, .docx"
        onChange={onChange}
        onClick={onClick}
      />
    </>
  )
}
